<form [formGroup]="temasAcuerdo" *ngIf="temasAcuerdoArray.length > 0">
  <div
    class="tema-section-drag"
    formArrayName="temas"
    cdkDropList
    [cdkDropListData]="temasAcuerdoArray.getRawValue()"
    (cdkDropListDropped)="dragDropTema($event, temasAcuerdoArray)"
  >
    <section
    cdkDrag
      cdkDragLockAxis="y"
      
      class="content-tema"
      *ngFor="let temaForm of temasAcuerdoArray.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div
        class="dragdrop-handle"
        cdkDragHandle
        [ngClass]="{
          'content-tema-numero-1': i % 2 === 0,
          'content-tema-numero-2': i % 2 !== 0,
          green: temaForm.get('edoTema')?.value === 3
        }"
      >
        {{ i + 1 }} 
      </div>
      <div class="content-tema-main">
        <div class="content-detalle-header">
          @if(!temaForm.get("showDetalleTema")?.value){

          <div
            *ngIf="temaForm.get('numEntregables')?.value > 0"
            matBadgeOverlap="false"
            matBadgeColor="warn"
            [matBadge]="temaForm.get('numEntregables')?.value + ' Entregables'"
            matBadgeSize="small"
            class="detalle-titulo"
          >
            Tema Confidencial
          </div>
          <p *ngIf="temaForm.get('numEntregables')?.value === 0">
            Tema Confidencial
          </p>

          }@else{
          <p class="detalle-titulo">{{ temaForm.get("nombreTema")?.value }}</p>
          }
          <button
            [ngClass]="{
            '!pointer-events-none': !temaForm.get('showDetalleTema')?.value,
          }"
            mat-icon-button
            aria-label="expand row"
            (click)="toggleExpand(temaForm)"
          >
            @if(temaForm.get("expanded")?.value) {
            <mat-icon>keyboard_arrow_up</mat-icon>
            } @else {
            <mat-icon>keyboard_arrow_down</mat-icon>
            }
          </button>
        </div>
        <div
          class="content-detalle-body"
          *ngIf="temaForm.get('expanded')?.value"
        >
          <section class="detalle-section-uno">
            <mat-form-field class="nuevo-catalogo-field">
              <mat-label>Tema*</mat-label>
              <input
                (blur)="controlTouched(temaForm.get('nombreTema'))"
                formControlName="nombreTema"
                name="nombreTema"
                class="nuevo-catalogo-input"
                type="text"
                maxlength="1000"
                matInput
                placeholder=""
              />
              <mat-hint align="end"
                >{{ temaForm.get("nombreTema")?.value.length }} / 1000</mat-hint
              >
              @if (temaForm.get('nombreTema')?.invalid &&
              temaForm.get('nombreTema')?.touched) {
              <mat-error>Campo obligatorio</mat-error>
              }
            </mat-form-field>
            @if(temaForm.get('edoTema')?.value != 3 &&
            temaForm.get('edoTema')?.value != 2){
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Acciones</mat-label>
              <mat-select
                (valueChange)="
                  actionSelected($event, temaForm.get('accion'), temaForm.getRawValue())
                "
                formControlName="accion"
                name="accion"
              >
                @for (accion of acciones; track accion) {
                <mat-option [disabled]="accion.disabled" [value]="accion.id">{{
                  accion.label
                }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            }@else if (temaForm.get('edoTema')?.value == 3 ||
            temaForm.get('edoTema')?.value == 2) {
            <mat-form-field class="nuevo-catalogo-field">
              <mat-label>Acciones</mat-label>
              <input
                [disabled]="true"
                [value]="
                  temaForm.get('edoTema')?.value == 3
                    ? 'Terminado'
                    : temaForm.get('edoTema')?.value == 2
                    ? 'Aplazado'
                    : 'NA'
                "
                class="nuevo-catalogo-input"
                type="text"
                maxlength="1000"
                matInput
                placeholder="Acción"
              />
            </mat-form-field>
            }
          </section>
          <section class="detalle-section-dos rich-text">
            @if(getContador(temaForm.get("descripcionTema_html")?.value)<=0&&
            temaForm.get("descripcionTema_html")?.touched) {
            <p class="!m-0 !pl-0 !pb-2 descripcionTema_html_error">
              Descripción*
            </p>
            }@else {
            <p class="!m-0 !pl-0 !pb-2 descripcionTema_html">Descripción*</p>
            }

            <div style="border: solid gray 1px">
              <ngx-editor-menu
                [disabled]="
                  temaForm.get('descripcionTema_html')?.disabled ?? false
                "
                *ngIf="editorInstances['editorInstanceId-'+i]"
                [editor]="editorInstances['editorInstanceId-'+i]"
                [toolbar]="toolbar"
              ></ngx-editor-menu>
            </div>

            <ngx-editor
              [disabled]="
                temaForm.get('descripcionTema_html')?.disabled ?? false
              "
              *ngIf="editorInstances['editorInstanceId-'+i]"
              [editor]="editorInstances['editorInstanceId-'+i]"
              formControlName="descripcionTema_html"
              [placeholder]="'Descipción...'"
            ></ngx-editor>
            <div class="!flex !item-end !justify-between">
              @if(getContador(temaForm.get("descripcionTema_html")?.value)<=0&&
              temaForm.get("descripcionTema_html")?.touched) {
              <p class="!m-0 !pl-3 descripcionTema_html_error">
                Campo obligatorio
              </p>
              <mat-hint align="end" class="descripcionTema_html_error">
                {{ getContador(temaForm.get("descripcionTema_html")?.value) }} /
                50000</mat-hint
              >
              }@else {
              <p class0="!m-0 "></p>
              <mat-hint align="end">
                {{ getContador(temaForm.get("descripcionTema_html")?.value) }} /
                50000</mat-hint
              >
              }
            </div>
          </section>
          <section class="detalle-section-tres">
            <mat-form-field class="mat-form-field-combo responsable-obligatorio">
            <mat-label
              class="required-field">
                {{!temaForm.get('esConfidencial')?.value ? 'Analista*' :'Analista' }}
            </mat-label>
              <mat-select
                (selectionChange)="
                  getNombreResponsable($event.value, temaForm, 'nombreAnalista')
                "
                (closed)="controlRespTouched(temaForm,'respAnalista')"
                formControlName="respAnalista"
                name="respAnalista"
              >
                @for (item of catUsuarios; track item.id) { @if(item.activo &&
                item.mostrar && item.rol === 1 || item.id ===
                oAcuerdo.id_fb_resp_analista) {
                <mat-option [value]="item.id">{{ item.nombre }}</mat-option>
                } }
              </mat-select>
              <mat-error
                *ngIf="
                  temaForm.get('respAnalista')?.invalid &&
                  temaForm.get('respAnalista')?.touched
                "
              >
                <span
                  *ngIf="temaForm.get('respAnalista')?.hasError('required')"
                >
                  Campo obligatorio
                </span>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-combo responsable-obligatorio">
              <mat-label class="required-field">
                {{!temaForm.get('esConfidencial')?.value ? 'Supervisor*' :'Supervisor' }}
              </mat-label>
              <mat-select
                (valueChange)="
                  getNombreResponsable($event, temaForm, 'nombreSupervisor')
                "
                    (closed)="controlRespTouched(temaForm,'respSupervisor')"
                formControlName="respSupervisor"
                name="respSupervisor"
              >
                @for (item of catUsuarios; track item.id) { @if(item.activo &&
                item.mostrar && item.rol === 2 || item.id ===
                oAcuerdo.id_fb_resp_analista) {
                <mat-option [value]="item.id">{{ item.nombre }}</mat-option>
                } }
              </mat-select>
              <mat-error
                *ngIf="
                  temaForm.get('respSupervisor')?.invalid &&
                  temaForm.get('respSupervisor')?.touched
                "
              >
                <span
                  *ngIf="temaForm.get('respSupervisor')?.hasError('required')"
                >
                  Campo obligatorio
                </span>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Coordinador*</mat-label>
              <mat-select
                (valueChange)="
                  getNombreResponsable($event, temaForm, 'nombreCoordinador')
                "
                (closed)="controlTouched(temaForm.get('respCoordinador'))"
                formControlName="respCoordinador"
                name="respCoordinador"
              >
                @for (item of catUsuarios; track item.id) { @if(item.activo &&
                item.mostrar && item.rol === 3 || item.id ===
                oAcuerdo.id_fb_resp_analista) {
                <mat-option [value]="item.id">{{ item.nombre }}</mat-option>
                } }
              </mat-select>
              <mat-error
                *ngIf="
                  temaForm.get('respCoordinador')?.invalid &&
                  temaForm.get('respCoordinador')?.touched
                "
              >
                <span
                  *ngIf="temaForm.get('respCoordinador')?.hasError('required')"
                >
                  Campo obligatorio
                </span>
              </mat-error>
            </mat-form-field>
          </section>
          <section class="detalle-section-cuatro">
            <mat-slide-toggle
              labelPosition="before"
              formControlName="esAprobado"
              name="esAprobado"
              class="example-margin"
              [color]="'primary'"
              hideIcon="true"
              [checked]="temaForm.get('esAprobado')?.value"
            >
              Aprobado
            </mat-slide-toggle>

            <mat-form-field class="mat-form-field-combo">
              <mat-label>Tipo*</mat-label>
              <mat-select
                panelWidth="250px"
                (closed)="controlTouched(temaForm.get('tipoTema'))"
                formControlName="tipoTema"
                name="tipoTema"
              >
                @for (item of catTipoTema; track item.id) {
                <mat-option [value]="item.id">{{
                  item.descripcion
                }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-slide-toggle
              labelPosition="before"
              formControlName="esConfidencial"
              name="esConfidencial"
              class="example-margin"
              [color]="'primary'"
              hideIcon="true"
              (change)="
                esConfidencialSelecionado(
                  $event,
                  temaForm
                )
              "
              [checked]="temaForm.get('esConfidencial')?.value"
            >
              Confidencial
            </mat-slide-toggle>
            <mat-form-field class="mat-form-field-combo">
              <mat-label>Categorización*</mat-label>
              <mat-select
                panelWidth="300px"
                (closed)="controlTouched(temaForm.get('categorizacion'),temaForm)"
                formControlName="categorizacion"
                name="categorizacion"
              >
                @for (item of catCategorizacion; track item.id) {
                <mat-option
                  [disabled]="
                    temaForm.get('esConfidencial')?.value
                      ? item.descripcion == 'C'
                      : item.descripcion !== 'C'
                  "
                  [value]="item.id"
                >
                  {{ item.descripcion }} -
                  {{ item.descripcionCompleta }}</mat-option
                >
                }
              </mat-select>
              <mat-error
                *ngIf="
                  temaForm.get('categorizacion')?.invalid &&
                  temaForm.get('categorizacion')?.touched
                "
              >
                <span
                  *ngIf="temaForm.get('categorizacion')?.hasError('required')"
                >
                  Campo obligatorio
                </span>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-combo">
              <mat-label>Categoría*</mat-label>
              <mat-select
                panelWidth="400px"
                (closed)="controlTouched(temaForm.get('id_categoria'))"
                formControlName="id_categoria"
                name="id_categoria"
              >
                <mat-select-trigger class="trigger-container">
                  <div
                    class="bullet color-{{
                      temaForm.get('id_categoria')?.value
                    }}"
                  ></div>
                  <div class="description">
                    {{
                      getCategoriaDescripcion(
                        temaForm.get("id_categoria")?.value
                      )
                    }}
                  </div>
                </mat-select-trigger>

                <mat-option *ngFor="let item of catCategoria" [value]="item.id">
                  <div class="option-container">
                    <div class="bullet color-{{ item.id }}"></div>
                    <div class="description">{{ item.descripcion }}</div>
                  </div>
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  temaForm.get('id_categoria')?.invalid &&
                  temaForm.get('id_categoria')?.touched
                "
              >
                <span
                  *ngIf="temaForm.get('id_categoria')?.hasError('required')"
                >
                  Campo obligatorio
                </span>
              </mat-error>
            </mat-form-field>
            <mat-slide-toggle
              labelPosition="before"
              formControlName="esImpreso"
              name="esImpreso"
              class="example-margin"
              [color]="'primary'"
              hideIcon="true"
              [checked]="temaForm.get('esImpreso')?.value"
            >
              Impreso
            </mat-slide-toggle>
          </section>
          <section class="detalle-section-cinco">
            <div
              class="detalle-section-cinco-header"
              *ngIf="temaForm.get('entradas')?.value.length > 0"
            >
              <div class="container-material">
                <p>Material</p>
              </div>
              <div class="container-entregables">
                <p>Entregables</p>
              </div>
              <div class="container-archivos drag">
                <p>Archivos</p>
              </div>
            </div>
            <div
              *ngIf="temaForm.get('entradas')?.value.length > 0"
              class="detalle-section-drag dragdrop-handle"
              cdkDropList
              [cdkDropListData]="temaForm.get('entradas')?.value"
              (cdkDropListDropped)="
                dropEntrada(
                  $event,
                  temaForm.get('entradas')?.value,
                  temaForm.get('idTema')?.value,
                  temaForm.get('entradas')
                )
              "
            >
              @for (entrada of temaForm.get('entradas')?.value; track entrada) {

              <div
                [ngStyle]="{
                  'pointer-events': showEntrada(entrada) ? 'none' : ''
                }"
                class="detalle-section-cinco-body !m-0"
                 cdkDragLockAxis="y"
      cdkDrag
              >
                <div
                  class="example-custom-placeholder"
                  *cdkDragPlaceholder
                ></div>

                @if (showEntrada(entrada)) {
                <p *ngIf="entrada.entregables.length == 0" class="!p-3 !m-0">
                  Material Confidencial
                </p>

                <div *ngIf="entrada.entregables.length > 0" class="!p-3 !m-0">
                  <div
                    style="width: max-content"
                    matBadgeOverlap="false"
                    matBadgeColor="warn"
                    [matBadge]="entrada.entregables.length + ' Entregables'"
                    matBadgeSize="small"
                    class="detalle-titulo"
                  >
                    Material Confidencial
                  </div>
                </div>
                }@else {
                <div class="container-material">
                  <div class="material">
                    <a
                      routerLink="/entrada/{{ entrada.idCategorizacion }}/{{
                        entrada.idEntrada
                      }}"
                      target="_blank"
                      class="entradaLink !underline !cursor-pointer"
                      [matTooltip]="
                        entrada.documentoSoporte ?? entrada.nombreEntrada
                      "
                      matTooltipPosition="above"
                      aria-label="nombre de la entrada"
                    >
                      {{ entrada.documentoSoporte ?? entrada.nombreEntrada }}
                    </a>

                    <mat-icon
                      class="!cursor-pointer"
                      *ngIf="
                        puedeElimarMaterial(entrada) ||
                        temaForm.get('nuevoTema')?.value
                      "
                      (click)="eliminarEntrda(entrada, temaForm)"
                      >delete</mat-icon
                    >
                  </div>
                </div>
                <div
                  class="container-entregables drag"
                  cdkDropList
                  [cdkDropListData]="entrada.entregables"
                  (cdkDropListDropped)="
                    dropEntregables(
                      $event,
                      entrada.entregables,
                      temaForm.get('idTema')?.value,
                      entrada.idEntrada,
                      temaForm.get('entradas')
                    )
                  "
                >
                  @for (entregable of entrada.entregables; track entregable) {

                  <div
                    *ngIf="
                      (entregable.edoEntregable !== 5 &&
                        entregable.edoEntregable !== 6) ||
                      (entregable.new &&
                        entregable.edoEntregable !== 5 &&
                        entregable.edoEntregable !== 6)
                    "
                    class="entregable mb-1"
                     cdkDragLockAxis="y"
      cdkDrag
                  >
                    <div
                      class="custom-placeholder-entregables"
                      *cdkDragPlaceholder
                    ></div>
                    <div class="estatus-container">
                      <a
                        href="{{ entregable.urlEntregable }}"
                        *ngIf="entregable.nombreEntregable.trim() !== ''"
                        target="_blank"
                        class="entradaLink !cursor-pointer"
                        [matTooltip]="entregable.nombreEntregable"
                        aria-label="Button that displays a tooltip when focused or hovered over"
                      >
                        {{
                          entregable.nombreEntregable.trim() !== ""
                            ? entregable.nombreEntregable.length > 22
                              ? entregable.nombreEntregable.substring(0, 22) +
                                "..."
                              : entregable.nombreEntregable
                            : "Adjuntar Archivo"
                        }}
                      </a>

                      <a
                        href="javascript:void(0)"
                        (click)="descargarEntregable(entrada,entregable)"
                        *ngIf="entregable.nombreEntregable.trim() == ''"
                        class="entradaLink !cursor-pointer"
                      >
                        Adjuntar Archivo
                      </a>
                      <div
                        class="bullet"
                        [ngClass]="{
                          'red-bullet': [1, 2, 3].includes(
                            entregable.edoEntregable ||
                              entregable.id_edo_entregable
                          ),
                          'green-bullet': [4].includes(
                            entregable.edoEntregable ||
                              entregable.id_edo_entregable
                          )
                        }"
                      ></div>
                    </div>
                  </div>
                  }
                </div>
                <div
                  class="container-archivos drag"
                  cdkDropList
                  [cdkDropListData]="entrada.archivos"
                  (cdkDropListDropped)="
                    dropFiles(
                      $event,
                      entrada.archivos,
                      temaForm.get('idTema')?.value,
                      entrada.idEntrada,
                      temaForm.get('entradas')
                    )
                  "
                >
                  @for (archivo of entrada.archivos; track archivo) {
                  <div
                    class="archivo"
                      cdkDragLockAxis="y"
      cdkDrag
                  >
                    <div
                      class="custom-placeholder-entregables"
                      *cdkDragPlaceholder
                    ></div>

                    <div class="archivo-actions">
                      <a
                        class="!underline !cursor-pointer"
                        (click)="verArchivo(archivo)"
                      >
                        {{
                          archivo.nombre_archivo &&
                          archivo.nombre_archivo.length > 18
                            ? archivo.nombre_archivo.substring(0, 18) + "..."
                            : archivo.nombre_archivo
                        }}
                      </a>

                      <div class="archivo-actions-buttons">
                        <button
                          (click)="verArchivo(archivo)"
                          mat-mini-fab
                          [disabled]="archivo.nuevo"
                          color="primary"
                          aria-label="Remove file"
                        >
                          <mat-icon>remove_red_eye</mat-icon>
                        </button>
                        <button
                          [disabled]="disabled"
                          (click)="
                            eliminarArchivo(
                              archivo,
                              temaForm,
                              entrada.idEntrada
                            )
                          "
                          mat-mini-fab
                          color="warn"
                          aria-label="Delete file"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>

              }
            </div>
            <section class="detalle-section-seis" style="margin-top: 2rem">
              <div
                class="select-custom-entradas"
                style="width: 100%; position: relative"
              >
                <mat-form-field    class="example-full-width" style="width: 100%">
                  <mat-label>Buscar Entrada</mat-label>
                  <mat-icon matPrefix>search</mat-icon>
                  <input
                    [ngClass]="{ 'desabilitar': (disabledEntrada(temaForm) | async) }"
                    type="text"
                    placeholder=""
                    aria-label="Number"
                    formControlName="entradaSelected"
                    name="entradaSelected"
                    matInput
                    (input)="onInput($event, temaForm)"
                     (focus)="onFocus(temaForm)"
                  (blur)="onBlur(temaForm)"
                  />
                </mat-form-field>
                <ul
                  *ngIf="temaForm.get('entradaSelected')?.value !== '' ||
                  mostrarEntradas"
                  class="custom-dropdown"
                >
                  @if (listaEntradas.length>0) {
                  <li *ngFor="let option of listaEntradas">
                    <button (click)="selectEntrada(option, temaForm)">
                      {{ option.nombreEntradaCompleto }}
                    </button>
                  </li>
                  } @else {
                  <li class="!p-1">No se encentra la entrada.</li>
                  }
                </ul>
              </div>
            </section>
          </section>

          <section
            class="detalle-section-ocho"
            *ngIf="!temaForm.get('nuevoTema')?.value"
          >
            <section class="detalle-section-siete">
              <div class="detalle-indicaciones">
                <mat-form-field class="nuevo-catalogo-field">
                  <mat-label>Indicaciones AB*</mat-label>
                  <input
                    (blur)="controlTouched(temaForm.get('indicacion'))"
                    formControlName="indicacion"
                    name="indicacion"
                    class="nuevo-catalogo-input"
                    type="text"
                    maxlength="2000"
                    matInput
                  />
                  <mat-error
                    *ngIf="
                      temaForm.get('indicacion')?.invalid &&
                      temaForm.get('indicacion')?.touched
                    "
                  >
                    <span
                      *ngIf="temaForm.get('indicacion')?.hasError('required')"
                    >
                      Campo obligatorio
                    </span>
                  </mat-error>
                  <mat-hint align="end">
                    {{ getContador(temaForm.get("indicacion")?.value) }} /
                    2000</mat-hint
                  >
                </mat-form-field>
              </div>
              <div class="detalle-indicaciones-acciones">
                <button
                  [disabled]="
                    temaForm.get('indicacion')?.value == '' &&
                    !temaForm.get('indicacion')?.touched
                  "
                  (click)="cancelarInciacion(temaForm.get('indicacion'))"
                  class="full-width-button"
                  mat-stroked-button
                >
                  CANCELAR
                </button>
                <button
                  [disabled]="temaForm.get('indicacion')?.value == ''"
                  (click)="
                    guardarIndicacion(temaForm.get('indicacion'), temaForm)
                  "
                  class="!uppercase full-width-button"
                  mat-flat-button
                  color="primary"
                >
                  GUARDAR
                </button>
              </div>
            </section>
            <div
              class="indicacion"
              *ngFor="let indicacionAB of temaForm.get('indicacionesAB')?.value | ascDesc: 'idIndicacion':'desc'"
            >
              <div class="indicacion-body">
                <p class="indicacion-fecha-persona !uppercase">
                  {{
                    indicacionAB.fechaIndicacion | date : "dd-MM-yyyy" : "UTC"
                  }}
                  -
                  {{ indicacionAB.usuario }}
                </p>
                <p class="indicacion-titulo">{{ indicacionAB.indicacion }}</p>
              </div>
              <button
                [disabled]="temaForm.get('indicacion')?.disabled"
                mat-icon-button
                aria-label="expand row"
                (click)="
                  editIndicacion(indicacionAB, temaForm.get('indicacion'))
                "
              >
                <mat-icon matPrefix>edit</mat-icon>
              </button>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</form>
